// extracted by mini-css-extract-plugin
export default {"dropzone_container":"audio-dropzone_dropzone_container__ohR0i","input":"audio-dropzone_input__DINmi"};